{
    "NAME": "TelModuleStatusListLanguage",
    "TelModuleStatusList_Title": "Status des Telefonmoduls",
    "TelModuleStatusList_Column_TelSys": "Telefonieserver",
    "TelModuleStatusList_Column_ClassName": "Klassenname",
    "TelModuleStatusList_Column_Type": "Typ",
    "TelModuleStatusList_Column_Version": "Version",
    "TelModuleStatusList_Column_Status": "Status",
    "TelModuleStatusList_Column_LastError": "Letzter Fehler",
    "TelModuleStatusList_Column_LastErrorDateTime": "Datum\/Uhrzeit des letzten Fehlers",
    "TelModuleStatusList_Empty": "Es sind keine Statusinformationen zum Telefonmodul verfügbar."
}